import reportsAPI from '../../../api/reports'

export default {
  async snapshot({commit, rootState, state}) {
    commit('setFetching', {report: state._snapshot, value: true})
    const tenantID = rootState.tenants.current.id
    const resp = await reportsAPI.snapshot({ tenantID })
    const data = resp.data.data
    commit('setReport', {report: state._snapshot, data})
    commit('setFetching', {report: state._snapshot, value: false})
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/reports/actions.js